import DocList from "./DocList";

const Page2 = () => {
    return (
     <><>
     {/* <h1>Informer Company Internal Team Documentation</h1> */}
        </><DocList />
        </>
    )
  };
  
  export default Page2;
  